import { useRootNavigation } from "expo-router";
import { useEffect, useState } from "react";

export const useIsNavReady = () => {
  const [isNavReady, setIsNavReady] = useState(false);
  const rootNavigation = useRootNavigation();

  useEffect(() => {
    const navlistener = rootNavigation?.addListener("state", () => {
      if (isNavReady) return;

      setIsNavReady(rootNavigation.isReady());
    });

    return () => navlistener && rootNavigation?.removeListener("state", navlistener);
  }, [rootNavigation, isNavReady]);

  return isNavReady;
};
